import { render, staticRenderFns } from "./modalCrearCarpeta.vue?vue&type=template&id=56087a45"
import script from "./modalCrearCarpeta.vue?vue&type=script&lang=js"
export * from "./modalCrearCarpeta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports